import ErrorMessageDictionary from './ErrorMessageDictionary';

export default ErrorMessageDictionary;
